import React from 'react'

import { Body1, Heading3 } from '@ui/Typography'

import styles from './AcquityHeader.module.scss'

interface Props {
  title: string
  description: string
}

export const AcquityHeader: React.FC<Props> = ({ title, description }) => {
  return (
    <div className={styles.aquitySection}>
      <hr className={styles.divider} />
      <Heading3 semibold>{title}</Heading3>
      <div className={styles.aquityDescription}>
        <Body1>{description}</Body1>
      </div>
      <hr className={styles.divider} />
    </div>
  )
}
